import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-accessible-accordion/dist/fancy-example.css';
import configStore from './common/store';
import routeConfig from './common/routeConfig';
import Root from './Root';
import './styles/index.scss';

const store = configStore();
ReactDOM.render(<Root store={store} routeConfig={routeConfig} />, document.getElementById('root'));
